import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Grid, Link as LinkMaterial } from '@material-ui/core';
import { BasicInput, CopyButton, CopyButtonVariant, TertiaryButton, Typography } from '@dev/ee-components';
import { getLandingPageCreatorStore } from '@/store/landingPageCreator/actions';
import { HotJarEvents, useHotJar } from '@/services/hooks/useHotjar';
import { useDashboardElementVisibility } from '@/services/hooks/useDashboardElementVisibility';
import { Step5ContentProps } from './types';
import { OpenInNewIconBlue } from './styles';

export const Step5Content = ({ isStepActive }: Step5ContentProps): JSX.Element => {
    const { t } = useTranslation();
    const { landingPageObject } = useSelector(getLandingPageCreatorStore);
    const { linkInBio: { isLinkInBioInsteadLandingPageVisible } } = useDashboardElementVisibility();

    const { showSurvey } = useHotJar();

    useEffect(() => {
        isStepActive && showSurvey(HotJarEvents.PublishLandingPage);
    }, [isStepActive]);

    const landingPageLinkButtonText = {
        copy: isLinkInBioInsteadLandingPageVisible ? t('linkinbiolinkbuttoncopy') : t('landingpagelinkbuttoncopy'),
        copied: isLinkInBioInsteadLandingPageVisible ? t('linkinbiolinkbuttoncopied') : t('landingpagelinkbuttoncopied'),
    };

    const openLinkToPreview = (e) => {
        e.preventDefault();
        window.open(landingPageObject?.LandingUrl, '_blank');
    };

    return (
        <Grid container xs={12} justifyContent="center">
            <Grid xs={12}>
                <Typography variant="body1">{t('landingpagelinkdescription')}</Typography>
            </Grid>
            <Grid xs={12} style={{ paddingTop: 16 }}>
                <BasicInput value={landingPageObject?.LandingUrl} />
            </Grid>
            <Grid xs={12} style={{ paddingTop: 4, marginLeft: 2 }}>
                <LinkMaterial
                    target="_blank"
                    rel="nofollow"
                    // href={landingPageObject?.LandingUrl}
                    onClick={openLinkToPreview}
                >
                    <TertiaryButton text={isLinkInBioInsteadLandingPageVisible ? t('linkinbiolinkpreviewbuttoninbio') : t('landingpagelinkpreviewbutton')} startIcon={<OpenInNewIconBlue />} />
                </LinkMaterial>
            </Grid>
            <Grid xs={12} style={{ paddingTop: 24 }}>
                <CopyButton
                    text={landingPageLinkButtonText}
                    variant={CopyButtonVariant.Website}
                    valueToCopy={landingPageObject?.LandingUrl}
                    disableSentenceCase
                />
            </Grid>
        </Grid>
    );
};
